import * as _ from 'lodash'
// import { getAbbreviation } from '../../helpers/state-abbreviation'
import moverHelper from '../../helpers/mover-helper'

export default {
  name: 'review',
  created () {
  
  },
  mounted () {
    this.getPartnersData()
  },
  data () {
    return {
      partners: []
    }
  },
  methods: {
    getPartnersData() {
      this.$http.get(process.env.API_URL+'/filters?order=created_at,asc').then(response => {
        response = response.data || response;
        console.log();
        response = _.groupBy(response,'client_id')
        _.forEach(response, (data,key)=>{
          let zipcodes =  _.join(_.map(data, 'filter_id'), ', ')
          let completed = data[0].completed == 1 ? true : false
          data = {}
          data.client_id = key
          data.completed= completed
          data.zipcodes = zipcodes
          this.partners.push(data)
        })
        console.log(this.partners)
      })
    },
    setCompleted(partner){
      console.log(partner.completed)
      let params = {
        "completed" : partner.completed
      }

      this.$http.post(process.env.API_URL+'/filters/update-by-client-id/'+partner.client_id, params).then(response => {
        console.log(response)
      })
      console.log(partner)
    },
    refreshUser(partner, index){
      if(confirm("Do you really want to delete this user?")){
        this.$http.delete(process.env.API_URL+'/user/'+partner.client_id).then(response => {
          console.log(response, index)
          this.partners.splice(index, 1);
        })
      }
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/Admin/admin.script.js